function formatDateToFrench(dateString) {
    // Define the month names in French
    const monthNames = [
        "Janvier", "Février", "Mars", "Avril", "Mai", "Juin",
        "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"
    ];

    // Parse the date string into a Date object
    const date = new Date(dateString);

    // Extract year, month (0-based), and day from the Date object
    const year = date.getFullYear();
    const monthIndex = date.getMonth(); // 0-based index
    const day = String(date.getDate()).padStart(2, '0'); // Ensure two digits

    // Get the French month name
    const monthName = monthNames[monthIndex];

    // Format the date
    return `${monthName} ${day}, ${year}`;
}

export default formatDateToFrench